import axiosFactory from "./axios.factory";

// Foto Manager (Trello 26.08.2026): quellenuebergreifende Bilderliste + Inhalte per Blob (Token-Header)
class PhotosService {
  async list(params) {
    const res = await axiosFactory().get("/photos", { params });
    return res.data.data || { total: 0, data: [] };
  }

  contentUrl(source, id, size) {
    return axiosFactory()
      .get(`/photos/${source}/${id}/content`, { params: size ? { size } : {}, responseType: "blob" })
      .then((res) => URL.createObjectURL(new Blob([res.data])));
  }
}

export default new PhotosService();
